import { formatDateExtended } from '@/utils/dateUtils';

export type JobCardDateSource = {
  actualEndAt?: string | null;
  actualStartAt?: string | null;
  plannedStartAt?: string | null;
};

const toUsableDateLabel = (raw?: string | null): string | null => {
  if (!raw || !raw.trim()) return null;
  const formatted = formatDateExtended(raw);
  return formatted || null;
};

/** Date-only label: actual end, then actual start, then planned start. */
export const getJobCardDateLabel = (
  source: JobCardDateSource
): string | null => {
  return (
    toUsableDateLabel(source.actualEndAt) ||
    toUsableDateLabel(source.actualStartAt) ||
    toUsableDateLabel(source.plannedStartAt)
  );
};

export const getJobCardEngineerLabel = (
  name?: string | null
): string | null => {
  const trimmed = name?.trim();
  return trimmed || null;
};
